var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('fa-icon',{staticClass:"text-luxcaddy",attrs:{"icon":"check"}}):_c('fa-icon',{staticClass:"text-red-500",attrs:{"icon":"times"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }